// Wires the Bambody spotlight-style product card — used by
// sections/bambody-product-spotlight.liquid (homepage, N products +
// silhouette switcher) and sections/bambody-product-main.liquid (PDP,
// single product). Markup comes from snippets/bam-spotlight-product-card.liquid.
//
// Per product: variant matching from radio pills → updates hidden variant-id,
// price, ATC label/disabled state, main image (variant.featured_image), and
// disables radios whose selection has no matching variant.
//
// Section-level: silhouette switcher buttons ([data-switch=<handle>]) toggle
// which [data-product] is visible.

(function () {
  const CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
  const money = (cents) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: CURRENCY }).format(cents / 100)

  // Find the main image for this product. In the combined-snippet layout
  // (PDP) the img is inside the same wrap; in the split-column spotlight
  // layout, it lives in [data-product-media][data-handle=...] elsewhere in
  // the section.
  function findMainImage(wrap) {
    const inline = wrap.querySelector('[data-main-image]')
    if (inline) return inline
    const handle = wrap.dataset.handle
    const section = wrap.closest('[data-spotlight], [data-spotlight-single]')
    if (!section || !handle) return null
    return section.querySelector(`[data-product-media][data-handle="${handle}"] [data-main-image]`)
  }

  function wireProduct(wrap) {
    if (wrap.dataset.bamSpotlightReady) return
    wrap.dataset.bamSpotlightReady = '1'

    const variantsEl = wrap.querySelector('[data-variants]')
    if (!variantsEl) return
    const variants = JSON.parse(variantsEl.textContent)
    const idInput  = wrap.querySelector('[data-variant-id]')
    const priceEl  = wrap.querySelector('[data-price]')
    const atcBtn   = wrap.querySelector('[data-atc]')
    const atcLbl   = wrap.querySelector('[data-atc-label]')
    const mainImg  = findMainImage(wrap)

    const currentSelection = () => {
      const values = []
      wrap.querySelectorAll('[data-option-index]').forEach((fs) => {
        const i = Number(fs.dataset.optionIndex) - 1
        const checked = fs.querySelector('input[type=radio]:checked')
        values[i] = checked ? checked.value : null
      })
      return values
    }

    const matchVariant = (vals) =>
      variants.find((v) => v.option1 === vals[0] && v.option2 === vals[1] && v.option3 === vals[2])

    const refreshAvailability = (vals) => {
      wrap.querySelectorAll('[data-option-index]').forEach((fs) => {
        const idx = Number(fs.dataset.optionIndex)
        fs.querySelectorAll('input[type=radio]').forEach((input) => {
          const test = vals.slice()
          test[idx - 1] = input.value
          const anyMatch = variants.some((v) => {
            if (idx === 1) return v.option1 === test[0] && v.available
            if (idx === 2) return v.option1 === test[0] && v.option2 === test[1] && v.available
            return v.option1 === test[0] && v.option2 === test[1] && v.option3 === test[2] && v.available
          })
          input.disabled = !anyMatch
        })
      })
    }

    const render = () => {
      const vals = currentSelection()
      refreshAvailability(vals)
      const v = matchVariant(vals)
      if (!v) {
        if (atcBtn) { atcBtn.disabled = true; atcLbl.textContent = 'unavailable' }
        return
      }
      if (idInput) idInput.value = v.id
      if (priceEl) priceEl.innerHTML = `<span>${money(v.price)}</span>`
      if (atcBtn) {
        if (v.available) {
          atcBtn.disabled = false
          atcLbl.textContent = `add to cart — ${money(v.price)}`
        } else {
          atcBtn.disabled = true
          atcLbl.textContent = 'sold out'
        }
      }
      if (v.featured_image && v.featured_image.src && mainImg) {
        mainImg.src = v.featured_image.src
      }
    }

    wrap.querySelectorAll('input[type=radio]').forEach((r) =>
      r.addEventListener('change', render),
    )
    render()

    // Thumbnail nav — thumbs live with the media (split layout puts them
    // in a sibling column, not inside `wrap`). Search the section for
    // thumbs matching this handle.
    const handle = wrap.dataset.handle
    const section = wrap.closest('[data-spotlight], [data-spotlight-single]')
    const thumbScope = handle && section
      ? section.querySelector(`[data-product-media][data-handle="${handle}"]`) || wrap
      : wrap
    thumbScope.querySelectorAll('[data-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const full = thumb.dataset.full
        if (full && mainImg) mainImg.src = full
        thumbScope.querySelectorAll('[data-thumb]').forEach((t) => t.classList.remove('is-current'))
        thumb.classList.add('is-current')
      })
    })
  }

  function wireSwitcher(section) {
    section.querySelectorAll('[data-switch]').forEach((btn) => {
      if (btn.dataset.bamSwitcherReady) return
      btn.dataset.bamSwitcherReady = '1'
      btn.addEventListener('click', () => {
        const target = btn.dataset.switch
        section.dataset.activeHandle = target
        // Toggle both halves — info wrappers ([data-product]) and split media
        // wrappers ([data-product-media]) share data-handle="<handle>".
        section.querySelectorAll('[data-product][data-handle], [data-product-media][data-handle]').forEach((p) => {
          const active = p.dataset.handle === target
          p.classList.toggle('is-active', active)
          if (active) p.removeAttribute('hidden'); else p.setAttribute('hidden', '')
        })
        section.querySelectorAll('[data-switch]').forEach((b) => b.classList.toggle('is-active', b === btn))
        section.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    })
  }

  function init(root = document) {
    root.querySelectorAll('[data-spotlight], [data-spotlight-single]').forEach((section) => {
      section.querySelectorAll('[data-product]').forEach(wireProduct)
      if (section.matches('[data-spotlight]')) wireSwitcher(section)
    })
  }

  document.addEventListener('DOMContentLoaded', () => init())
  document.addEventListener('shopify:section:load', (e) => init(e.target))
})()
